export default {
  name: 'Adan_detector',

  lookup() {
    return 'es';
  }
};
